// extracted by mini-css-extract-plugin
export default {"progress":"style_progress__m+Tmv","wrapper":"style_wrapper__9wwpI","image":"style_image__6jHCf","description":"style_description__mgVbP"};